import React, { forwardRef, useState } from 'react';
import IconWithButton from 'src/components/Common/IconWithButton';
import calenderIcon from 'src/assets/svgs/calenderIcon.svg';
import { breakPoints } from 'src/constants/general';

import DatePicker from 'react-datepicker';
import { useDeviceDetect } from 'src/hooks/useDeviceDetect';
import { dateTimeFormate } from 'src/utils/function';

const TaskSortFilter = ({ setSortBy, sortBy, setFilterBy, filterBy, dateProps }: any) => {
    const { isMobile }: any = useDeviceDetect();
    const [calenderOpenStartDateTo, setCalenderOpenStartDateTo] = useState(false);
    const [calenderOpenEndDateTo, setCalenderOpenEndDateTo] = useState(false);
    const [calenderOpenStartDateFrom, setCalenderOpenStartDateFrom] = useState(false);
    const [calenderOpenEndDateFrom, setCalenderOpenEndDateFrom] = useState(false);

    const {
        startDateTo,
        setStartDateTo,
        formateStartDateTo,
        setFormateStartDateTo,
        startDateFrom,
        setStartDateFrom,
        formateStartDateFrom,
        setFormateStartDateFrom,
        endDateTo,
        setEndDateTo,
        formateEndDateTo,
        setFormateEndDateTo,
        endDateFrom,
        setEndDateFrom,
        formateEndDateFrom,
        setFormateEndDateFrom,
    } = dateProps;

    const getNewDate = (date: any) => {
        const newDate = new Date(date);
        return dateTimeFormate(newDate, 'DD MMM, YYYY');
    };

    const onChangeStartDateTo = (date: any) => {
        setStartDateTo(date);
        setCalenderOpenStartDateTo(false);
        if (date) {
            const formattedNewStartDateTo = getNewDate(date);
            setFormateStartDateTo(formattedNewStartDateTo);
            setFilterBy((prevData: any) => ({
                ...prevData,
                startDateTo: dateTimeFormate(formattedNewStartDateTo, 'YYYY-MM-DD HH:mm:ss'),
            }));
        }
    };
    const onChangeStartDateFrom = (date: any) => {
        setStartDateFrom(date);
        setCalenderOpenStartDateFrom(false);
        if (date) {
            const formattedNewStartDateFrom = getNewDate(date);
            setFormateStartDateFrom(formattedNewStartDateFrom);
            setFilterBy((prevData: any) => ({
                ...prevData,
                startDateFrom: dateTimeFormate(formattedNewStartDateFrom, 'YYYY-MM-DD HH:mm:ss'),
            }));
        }
    };

    const onChangeEndDateTo = (date: any) => {
        setEndDateTo(date);
        setCalenderOpenEndDateTo(false);
        if (date) {
            const formattedNewEndDate = getNewDate(date);
            setFormateEndDateTo(formattedNewEndDate);
            setFilterBy((prevData: any) => ({
                ...prevData,
                endDateTo: dateTimeFormate(formattedNewEndDate, 'YYYY-MM-DD HH:mm:ss'),
            }));
        }
    };
    const onChangeEndDateFrom = (date: any) => {
        setEndDateFrom(date);
        setCalenderOpenEndDateFrom(false);
        if (date) {
            const formattedNewEndDate = getNewDate(date);
            setFormateEndDateFrom(formattedNewEndDate);
            setFilterBy((prevData: any) => ({
                ...prevData,
                endDateFrom: dateTimeFormate(formattedNewEndDate, 'YYYY-MM-DD HH:mm:ss'),
            }));
        }
    };

    const CustomStartDateToInput = forwardRef((props, ref: any) => (
        <div className="" ref={ref}>
            <IconWithButton title={formateStartDateTo} icon={calenderIcon} isMoreClass={'max-lg:py-3 max-lg:gap-2 max-lg:rounded-xl max-lg:w-full'} onclick={() => setCalenderOpenStartDateTo(true)} />
        </div>
    ));
    const CustomStartDateFromInput = forwardRef((props, ref: any) => (
        <div className="" ref={ref}>
            <IconWithButton
                title={formateStartDateFrom}
                icon={calenderIcon}
                isMoreClass={'max-lg:py-3 max-lg:gap-2 max-lg:rounded-xl max-lg:w-full'}
                onclick={() => setCalenderOpenStartDateFrom(true)}
            />
        </div>
    ));
    const CustomEndDateToInput = forwardRef((props, ref: any) => (
        <div className="" ref={ref}>
            <IconWithButton title={formateEndDateTo} icon={calenderIcon} isMoreClass={'max-lg:py-3 max-lg:gap-2 max-lg:rounded-xl max-lg:w-full'} onclick={() => setCalenderOpenEndDateTo(true)} />
        </div>
    ));
    const CustomEndDateFromInput = forwardRef((props, ref: any) => (
        <div className="" ref={ref}>
            <IconWithButton title={formateEndDateFrom} icon={calenderIcon} isMoreClass={'max-lg:py-3 max-lg:gap-2 max-lg:rounded-xl max-lg:w-full'} onclick={() => setCalenderOpenEndDateFrom(true)} />
        </div>
    ));

    return (
        <div className="mt-4 px-5 md:px-5 h-[calc(100vh-270px)] overflow-y-auto scrollbar-hide">
            <h4 className="text-black text-base font-medium">Filter By</h4>

            <div
                className={`mt-6 mb-4 flex gap-2 max-lg:gap-0 max-lg:justify-between
                     ${isMobile < breakPoints.mobile ? 'mobile_datepicker_responsive' : isMobile < breakPoints.tablet ? 'tablet_datepicker_responsive' : ''}`}
            >
                <div className="flex flex-col">
                    <p className="text-xs mb-2">StartDate From</p>
                    <DatePicker
                        selected={startDateFrom}
                        onChange={onChangeStartDateFrom}
                        open={calenderOpenStartDateFrom}
                        onClickOutside={() => setCalenderOpenStartDateFrom(false)}
                        customInput={<CustomStartDateFromInput />}
                        showPopperArrow={false}
                        calendarClassName="sort-custom-datepicker bg-black text-gray-100 w-[270px]"
                        wrapperClassName="!w-full"
                        // minDate={toDay.toDate()}
                    ></DatePicker>
                </div>
                <div className="flex flex-col">
                    <p className="text-xs mb-2">StartDate To</p>
                    <DatePicker
                        selected={startDateTo}
                        onChange={onChangeStartDateTo}
                        open={calenderOpenStartDateTo}
                        onClickOutside={() => setCalenderOpenStartDateTo(false)}
                        customInput={<CustomStartDateToInput />}
                        showPopperArrow={false}
                        calendarClassName="sort-custom-datepicker bg-black text-gray-100 w-[270px]"
                        wrapperClassName="!w-full"
                        // minDate={toDay.toDate()}
                    ></DatePicker>
                </div>
            </div>

            <div
                className={`mt-6 mb-4 flex gap-2 max-lg:gap-0 max-lg:justify-between
                     ${isMobile < breakPoints.mobile ? 'mobile_datepicker_responsive' : isMobile < breakPoints.tablet ? 'tablet_datepicker_responsive' : ''}`}
            >
                <div className="flex flex-col">
                    <p className="text-xs mb-2">End Date From</p>
                    <DatePicker
                        selected={endDateFrom}
                        onChange={onChangeEndDateFrom}
                        open={calenderOpenEndDateFrom}
                        onClickOutside={() => setCalenderOpenEndDateFrom(false)}
                        customInput={<CustomEndDateFromInput />}
                        showPopperArrow={false}
                        calendarClassName="sort-custom-datepicker bg-black text-gray-100 w-[270px]"
                        wrapperClassName="!w-full"
                        // minDate={toDay.toDate()}
                    ></DatePicker>
                </div>
                <div className="flex flex-col">
                    <p className="text-xs mb-2">End Date To</p>
                    <DatePicker
                        selected={endDateTo}
                        onChange={onChangeEndDateTo}
                        open={calenderOpenEndDateTo}
                        onClickOutside={() => setCalenderOpenEndDateTo(false)}
                        customInput={<CustomEndDateToInput />}
                        showPopperArrow={false}
                        calendarClassName="sort-custom-datepicker bg-black text-gray-100 w-[270px]"
                        wrapperClassName="!w-full"
                        // minDate={toDay.toDate()}
                    ></DatePicker>
                </div>
            </div>
        </div>
    );
};

export default TaskSortFilter;
